import { render, staticRenderFns } from "./CardPhotoJourneyCompare.vue?vue&type=template&id=4e9c840a"
import script from "./CardPhotoJourneyCompare.vue?vue&type=script&lang=js"
export * from "./CardPhotoJourneyCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports